module.exports = __webpack_public_path__ + "static/img/ggsc2.4084f6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/ggsc2.jpg
// module id = nvM+
// module chunks = 0